/**
 * Put arbitrary text on the clipboard, honestly (T524).
 *
 * A SIBLING of Done.tsx's `copyHttps`, deliberately not a caller and not a
 * refactor of it. `copyHttps` opens with `url.startsWith('https:')`, which is
 * SEC-9 - a URL-SCHEME rule guarding a payment link against being handed a
 * `javascript:`/`data:` value. That rule is meaningless for a phone number or a
 * rendered message body, and wrapping it would either force a fake scheme onto
 * plain text or require punching a hole in a money-path guard. `copyHttps`
 * therefore stays exactly where it is, on the deposit path, with its own spec
 * (test/client/deposit-copy.spec.tsx) unmoved; the eight lines below are the
 * part that genuinely transfers.
 *
 * WHY IT RETURNS false RATHER THAN THROWING. So the button can tell the truth.
 * A silent no-op is the worst outcome here: Helen taps "Copy message", nothing
 * visible happens, and she pastes whatever was on the clipboard before - which
 * on a shared kiosk may be another customer's details.
 *
 * WHAT ACTUALLY FAILS, corrected against this repo's own findings. An earlier
 * draft of this justified the fallback with "the kiosk is served over plain HTTP
 * on the LAN, so navigator.clipboard is undefined". That is NOT this system:
 * server/auth.ts sets the session cookie `Secure` unconditionally and states the
 * kiosk "is deployed on Railway (HTTPS) and nowhere else" - so a plain-http LAN
 * kiosk could not hold a session, and this route would 401 long before the
 * clipboard mattered. (client/feedback/recorder.ts carries the same correction
 * for the same wrong claim, made once already in T512 M3.) The failures that ARE
 * reachable on a secure origin: the document not being focused, a Permissions
 * Policy denying clipboard-write, an iframe without the permission, and Safari's
 * requirement that the write happen inside the user-gesture task. All of them
 * reject rather than throwing synchronously, and all of them mean the same thing
 * to Helen: it did not copy, read the number off the screen instead.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    // Optional-chained: `navigator.clipboard` is undefined in jsdom without a
    // stub and on a non-secure origin, and a bare property read would throw
    // rather than resolve false.
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
